import React from 'react';
import './homebody.css';
import myimage from '../../assets/TMF PERSONAL POTRAIT.jpg';

const Homebody = () => {
  return (
    <div className="home-section">

      <div className="home-previous rotate-scale-up-hor">
        <h3>
          <i>HOVER/CLICK ON THE CARDS ABOVE</i>
        </h3>
      </div>

      <div className="home-content">

        <h2>
          <b>
            AI, Spatial Computing, Infrastructure & Impact:
          </b>
          <br />

          <i>
            I build at the intersection of intelligent technology and
            the physical world — exploring how AI, digital twins and
            emerging interfaces can turn complex systems into
            something people can understand, participate in and shape.
          </i>
        </h2>

        <h4 className="text-muted mt-3">
          My focus: <strong>Infrastructure + Impact.</strong>
        </h4>

      </div>

      <br />
      <br />

      <div className="home-image-writing">

        <div className="home-image">
          <img
            src={myimage}
            alt="Personal portrait of Goodness Ononogbu"
          />
        </div>

        <div className="home-writing">

          <h3>
            <b>
              <i>This is where I come in.</i>
            </b>
          </h3>

          <p className="lead">
            <strong>Infrastructure + Impact</strong> — designing systems
            that connect technology, people and the real world.
          </p>

          <h3>
            <b>
              I am interested in what happens when technology moves
              beyond the screen.
            </b>
          </h3>

          <p>
            My work sits at the intersection of Artificial Intelligence,
            spatial computing, digital twins, robotics and sustainability.
            I am particularly interested in the systems that sit between
            intelligence and execution: how technology can help people
            understand complex environments, coordinate action and
            create measurable outcomes.
          </p>

          <p>
            That thinking is now taking shape through{' '}
            <strong>Keruvva</strong> — a participation infrastructure
            platform exploring how people will interact with and participate in 
            digital representations of physical places.
          </p>

          <p>
            The broader ambition is simple:
            <strong> build technology that does not merely describe the
            world, but helps people participate in changing it.</strong>
          </p>

          <div className="home-keruvva-link">
            <a href="keruvva.com" className="btn btn-outline-light">
              EXPLORE KERUVVA ↗
            </a>
          </div>

        </div>

      </div>

    </div>
  );
};

export default Homebody;